import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./About.css";
import LoginModal from "./LoginModal";
import logoApp from "../assets/logo-app.png";
import iconMail from "../assets/icon-mail.svg";
import iconThreads from "../assets/icon-threads.svg";
import iconFacebook from "../assets/icon-facebook.svg";
import iconInstagram from "../assets/icon-instagram.svg";

const About = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);

  return (
    <div className="about-page">
      {/* Navigation Bar */}
      <nav className="landing-nav">
        <div className="nav-container">
          <div className="nav-brand">
            <img src={logoApp} alt="Runstreak Dashboard" className="nav-logo" />
            <span className="nav-brand-text">Runstreak Dashboard</span>
          </div>
          <div className="nav-menu">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/pricing" className="nav-link">Pricing</Link>
            <Link to="/help" className="nav-link">Help</Link>
            <button onClick={() => setShowLoginModal(true)} className="nav-link nav-link-outlined">Login</button>
            <button onClick={() => setShowLoginModal(true)} className="nav-link nav-link-primary">Get Started</button>
          </div>
        </div>
      </nav>

      {/* Login Modal */}
      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />

      <div className="about-container">
        <div className="about-header">
          <h1>About Runstreak Dashboard</h1>
          <p className="about-subtitle">
            Building the ultimate running streak tracker for dedicated runners worldwide
          </p>
        </div>

        <section className="about-section">
          <h2>Our Mission</h2>
          <p>
            Runstreak Dashboard was created to help runners build and maintain
            consistent running habits through streak tracking, social motivation,
            and comprehensive analytics. We believe that consistency is the key to
            long-term success in running, and our platform is designed to make
            tracking your daily runs effortless and motivating.
          </p>
        </section>

        <section className="about-section">
          <h2>What We Offer</h2>
          <p>
            Our platform combines powerful features to support your running journey:
          </p>
          <ul>
            <li>
              <strong>Streak Tracking:</strong> Monitor your current and longest
              running streaks with visual indicators and motivational reminders.
            </li>
            <li>
              <strong>Strava Integration:</strong> Seamlessly sync your activities
              from Strava with automatic updates via webhooks.
            </li>
            <li>
              <strong>Manual Uploads:</strong> Upload GPX and TCX files from any
              running app or GPS device.
            </li>
            <li>
              <strong>Detailed Analytics:</strong> Track your pace zones, split
              analysis, location data, and performance metrics over time.
            </li>
            <li>
              <strong>Social Features:</strong> Connect with friends, compare
              streaks, and compete on leaderboards.
            </li>
            <li>
              <strong>Data Export:</strong> Export your activity data to CSV for
              further analysis.
            </li>
          </ul>
        </section>

        <section className="about-section">
          <h2>Our Story</h2>
          <p>
            Runstreak Dashboard is a passion project built by runners, for runners.
            We understand the challenges of maintaining consistency and the
            motivation that comes from seeing your streak grow day after day. Our
            goal is to provide a free, accessible platform that helps runners stay
            accountable and motivated on their journey.
          </p>
        </section>

        <section className="about-section">
          <h2>Privacy & Security</h2>
          <p>
            We take your data privacy seriously. We use industry-standard security
            practices to protect your information and never sell your data to third
            parties. Your Strava connection uses OAuth authentication, which means
            we never have access to your Strava password. You can disconnect or
            delete your account at any time from your profile settings.
          </p>
        </section>

        <section className="about-section">
          <h2>Contact Us</h2>
          <p>
            We'd love to hear from you! Whether you have questions, feedback, or
            feature requests, please don't hesitate to reach out:
          </p>
          <p>
            <a href="mailto:hello@runstreakdashboard.com">
              hello@runstreakdashboard.com
            </a>
          </p>
        </section>
      </div>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-column">
            <div className="footer-brand">
              <img src={logoApp} alt="Runstreak Dashboard" className="brand-logo" />
              <span>Runstreak Dashboard</span>
            </div>
            <p>Keep your running streak alive with the most motivational fitness app.</p>
            <div className="social-links">
              <a href="#threads"><img src={iconThreads} alt="Threads" /></a>
              <a href="#facebook"><img src={iconFacebook} alt="Facebook" /></a>
              <a href="#instagram"><img src={iconInstagram} alt="Instagram" /></a>
            </div>
          </div>

          <div className="footer-column">
            <h4>Product</h4>
            <ul>
              <li><a href="/#features">Features</a></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><a href="#download">Download</a></li>
              <li><a href="#updates">Updates</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Support</h4>
            <ul>
              <li><Link to="/help">Help Center</Link></li>
              <li><a href="mailto:hello@runstreakdashboard.com">Contact Us</a></li>
              <li><a href="mailto:hello@runstreakdashboard.com">Bug Reports</a></li>
              <li><a href="mailto:hello@runstreakdashboard.com">Feature Requests</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><a href="mailto:hello@runstreakdashboard.com">Careers</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <p>© 2025 Runstreak. All rights reserved.</p>
          <div className="footer-contact">
            <img src={iconMail} alt="" />
            <a href="mailto:hello@runstreakdashboard.com">hello@runstreakdashboard.com</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default About;
